import { render, staticRenderFns } from "./distributePage.vue?vue&type=template&id=363b9510&scoped=true"
import script from "./distributePage.vue?vue&type=script&lang=js"
export * from "./distributePage.vue?vue&type=script&lang=js"
import style0 from "./distributePage.vue?vue&type=style&index=0&id=363b9510&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "363b9510",
  null
  
)

export default component.exports